var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconLogin = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_280",
  "data-name": "Group 280",
  transform: "translate(-1052.713 -40.713)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_965",
  "data-name": "Group 965",
  transform: "translate(1053 41)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2459",
  "data-name": "Path 2459",
  d: "M7.94,10.948A2.974,2.974,0,1,0,4.966,7.974,2.962,2.962,0,0,0,7.94,10.948Zm0,1.983C5.63,12.931,1,14.091,1,16.4V18.88H14.88V16.4C14.88,14.091,10.25,12.931,7.94,12.931Z",
  transform: "translate(1.831 -2.083)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_713",
  "data-name": "Group 713",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_78",
  "data-name": "Ellipse 78",
  transform: "translate(-0.287 -0.287)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.25,
  fill: "none"
})))))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLogin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_login.1e87073b.svg";
export { ForwardRef as ReactComponent };